import { Component } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { AppConstants } from '@core/constants';

@Component({
  selector: 'app-integration-nova',
  templateUrl: './integration-nova.component.html',
  styleUrls: ['./integration-nova.component.scss']
})
export class IntegrationNovaComponent {
  public discountCode: string = "INSCYD25";

  constructor(
    private readonly snackBar: MatSnackBar,
  ) {}

  public copyToClipboard(): void {
    navigator.clipboard.writeText(this.discountCode).then(() => {
      this.snackBar.open('Copied to clipboard!', 'OK', AppConstants.TOAST_CONFIG.SUCCESS);
    }).catch(err => {
      this.snackBar.open('Failed to copy to clipboard!', 'OK', AppConstants.TOAST_CONFIG.ERROR);
    });
  }
}
